import { render, staticRenderFns } from "./PhoneInputV1.vue?vue&type=template&id=18d1cee2&"
import script from "./PhoneInputV1.vue?vue&type=script&lang=js&"
export * from "./PhoneInputV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports